import { Spinner, VStack } from "@gluestack-ui/themed";

export const DraftLoading = () => {
  return (
    <VStack
      w="$full"
      h="$100vh"
      flex={1}
      alignItems="center"
      justifyContent="center"
    >
      <Spinner color="$primary700" />
    </VStack>
  );
};
